import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';

const Collapse = (props) => {
  let className = 'collapse-wrapper';
  if (props.className) className += ` ${props.className}`;
  return (
    <div className={className}>
      <Title
        title={props.title}
        titleElement={props.titleElement}
        collapsed={props.collapsed}
        onClick={props.onClick}
        hideChevron={props.hideChevron}
      />
      {!props.collapsed && props.children}
    </div>
  );
};

Collapse.propTypes = {
  title: PropTypes.string,
  titleElement: PropTypes.element,
  collapsed: PropTypes.bool,
  onClick: PropTypes.func,
  hideChevron: PropTypes.bool,
};

Collapse.defaultProps = {
  collapsed: true,
};

export const UncontrolledCollapse = (props) => {
  let initialValue = props.initialValue !== undefined ? props.initialValue : true;
  let [collapsed, setCollapsed] = useState(initialValue);

  function toggleCollapsed() {
    setCollapsed(!collapsed);
  }

  return (
    <Collapse {...props} collapsed={collapsed} onClick={toggleCollapsed}>
      {props.children}
    </Collapse>
  );
};

const Title = ({ title = '', titleElement = null, collapsed, onClick, hideChevron = false }) => {
  let chevron = collapsed ? 'chevron-right' : 'chevron-down';
  let className = 'small-title collapse-title top clickable ';
  className += collapsed ? 'collapsed' : 'not-collapsed';
  return (
    <span className={className} onClick={onClick}>
      {!hideChevron && (
        <>
          <Icon
            height="10px"
            width="10px"
            className="chevron mr-2"
            src={chevron}
            style={{ display: 'flex', float: 'left' }}
          />{' '}
        </>
      )}
      {titleElement || title}
    </span>
  );
};

export default Collapse;
